const LAMMainCart = () => {
  // ----------------------------------------------------------------------- //
  // Shopify
  
  const liquidData = JSON.parse(
    document.getElementById(`lam-cart-data`).textContent
  );

  const currencySymbol = liquidData.currencySymbol.replace(`{{amount}}`, ``).replace(`<span class=money>$ USD</span>`, `$`);

  // ----------------------------------------------------------------------- //
  // DOM

  const cartItemNodes = document.querySelectorAll(`.cart-item`);
  const quantityAdjustors = document.querySelectorAll(`.cart-item__quantity-adjust`);
  const removeButtons = document.querySelectorAll(`.cart-item__remove`);
  const loadHideable = document.querySelectorAll(`.load-hideable`);

  if (loadHideable?.[0]) {
    setTimeout(() => {
      loadHideable.forEach(node => {
        node.classList.remove(`disabled`);
      });
    }, 1000);
  }

  // ----------------------------------------------------------------------- //
  // methods

  const merge = () => {
    if (!liquidData?.items?.length) {
      return;
    }

    let mergedItems = {};

    liquidData.items.forEach(item => {
      if (item?.properties?.__addons?.[0]) {
        mergedItems[item.variant_id] = {
          addOns: [],
          ...item
        }
      }
    });

    liquidData.items.forEach(item => {
      if (!item?.properties?.__sourceVariant) {
        return;
      }
      
      const source = mergedItems?.[item?.properties?.__sourceVariant];

      if (!source) {
        return;
      }

      source.addOns.push(item);
    });
  }

  const appendAddons = () => {
    if (cartItemNodes?.[0]) {
      cartItemNodes.forEach(sourceItemNode => {
        const sourceVariantId = sourceItemNode.getAttribute(`data-variantid`);
        const sourceUuid = sourceItemNode.getAttribute(`data-uuid`);
        const sourceAddonIds = JSON.parse(sourceItemNode.getAttribute(`data-addons`));
        const priceNode = sourceItemNode.querySelector(`.composite-price`);
        const metadataContainer = sourceItemNode.querySelector(`.cart-item__metadata`);

        const sourceVariant = liquidData.items.find(({ id, properties }) => {
          return parseInt(id) === parseInt(sourceVariantId) && properties?.__uuid?.toString() === sourceUuid?.toString();
        });

        if (!sourceVariant) {
          const basicVariant = liquidData.items.find(( {id }) => {
            return parseInt(id) === parseInt(sourceVariantId);
          });

          const lineItemPrice = basicVariant.line_price;

          priceNode.innerHTML = `${currencySymbol}${parseFloat(lineItemPrice / 100).toFixed(2)}`;

          return;
        }

        let lineItemPrice = sourceVariant.line_price;

        const setPrice = (withMetadata) => {
          priceNode.innerHTML = `${currencySymbol}${parseFloat(lineItemPrice / 100).toFixed(2)}`;

          if (withMetadata) {
            setTimeout(() => {
              metadataContainer.classList.add(`active`);
            }, 100);
          }
        }

        if (!sourceAddonIds?.[0]) {
          setPrice();
          return;
        }

        const linkedAddOns = liquidData.items.filter(({ id, properties }) => {
          return sourceAddonIds?.includes(id) && properties?.__uuid?.toString() === sourceUuid?.toString();
        });

        if (!linkedAddOns?.[0]) {
          setPrice();
          return;
        }

        metadataContainer.innerHTML = ``;

        const addOnText = {
          lid: {
            addOn: null,
            label: `Extra Lid`,
            title: `None`
          },
          sleeve: {
            addOn: null,
            label: `Silicone Sleeve`,
            title: `None`
          },
          stand: {
            addOn: null,
            label: `Desk Stand`,
            title: `None`
          }
        };

        const priceList = sourceItemNode.querySelector(`.cart-item__price__list`);

        if (priceList) {
          const priceItem = document.createElement(`div`);

          priceItem.classList.add(`cart-item__price__separator`);
          priceItem.classList.add(`lam-caption`);
          priceItem.classList.add(`cart-item__price--novalue`);

          priceItem.innerText = `-`;

          priceList.appendChild(priceItem);
        }

        linkedAddOns.forEach(addOn => {
          const parsedProductType = addOn?.title?.toLowerCase();

          let isStand = parsedProductType?.includes(` stand (`);

          if (parsedProductType?.includes(` lid (`)) {
            addOnText.lid.addOn = addOn;
            addOnText.lid.title = addOn.title
              .replace(` (Original memobottle)`, ``)
              .replace(` (Stainless Steel memobottle`, ``)
              .replace(` Lid`, ``);

          } else if (parsedProductType?.includes(`silicone sleeve`)) {
            addOnText.sleeve.addOn = addOn;
            addOnText.sleeve.title = addOn.title
              .replace(` (Original memobottle)`, ``)
              .replace(` (Stainless Steel memobottle`, ``)
              .replace(` Silicone Sleeve`, ``)
              .replace(` Silicone sleeve`, ``)
              .replace(`A5 - `, ``)
              .replace(`A6 - `, ``)
              .replace(`A7 - `, ``)
              .replace(`Slim - `, ``)
              .replace(`SLIM - `, ``);

          } else if (isStand) {
            addOnText.stand.addOn = addOn;
            addOnText.stand.title = addOn.title
              .replace(` (Original memobottle)`, ``)
              .replace(` (Stainless Steel memobottle`, ``)
              .replace(` Desk Stand`, ``)
              .replace(` Desk stand`, ``);
          }

          lineItemPrice += addOn.price * addOn.quantity;

          if (addOn?.properties?.__overlayImage) {
            const imageNode = sourceItemNode.querySelector(`.cart-item__image`);

            const overlay = document.createElement(`div`);
            overlay.classList.add(`cart-item__image__overlay`);
            
            if (isStand) {
              overlay.style.zIndex = '100';
            }

            const image = document.createElement(`img`);
            image.setAttribute(`src`, addOn.properties.__overlayImage);

            overlay.appendChild(image);
            imageNode.appendChild(overlay);
          }
        });

        let attributeText = `
          <h4 class="lam-caption">Material: ${sourceVariant.properties.__material}</h4>
        `;

        Object.keys(addOnText).forEach(key => {
          const addOn = addOnText[key];

          let title = addOn.title;

          if (title?.includes(` - `)) {
            title = title.split(` - `)[1];
          }

          attributeText += `
            <h4 class="lam-caption">${addOn.label}: ${title}</h4>
          `;

          if (priceList) {
            const priceItem = document.createElement(`div`);

            priceItem.classList.add(`lam-caption`);

            if (!addOn?.addOn?.price) {
              priceItem.classList.add(`cart-item__price--novalue`);
            }

            priceItem.innerText = addOn?.addOn?.price ? `+ ${currencySymbol}${parseFloat(addOn.addOn.price / 100).toFixed(2)} ${liquidData.currency}` : `-`;

            priceList.appendChild(priceItem);
          }
        });

        metadataContainer.innerHTML = attributeText;

        //

        setPrice(true);
      });
    }
  };

  const addClickListeners = () => {
    if (!removeButtons?.[0]) {
      return false;
    }

    //
    // every composite remover needs to also delete any linked addons

    removeButtons.forEach(button => {
      const sourceUuid = button.getAttribute(`data-uuid`);
      
      let sourceVariantId = button.getAttribute(`data-variantid`);

      if (!sourceVariantId) {
        return;
      }

      sourceVariantId = parseInt(sourceVariantId);

      button.addEventListener(`click`, async event => {
        event.preventDefault();

        const itemsToRemove = liquidData.items.filter(({ id, properties }) => {
          return parseInt(sourceVariantId) === parseInt(properties?.__sourceVariant) && sourceUuid?.toString() === properties?.__uuid?.toString();
        }).map(({ key }) => key?.toString());

        const sourceItemKey = liquidData.items.find(({ id, properties }) => {
          return parseInt(sourceVariantId) === parseInt(id) && sourceUuid?.toString() === properties?.__uuid?.toString();
        })?.key?.toString();

        itemsToRemove.push(sourceItemKey);

        const updates = {};

        itemsToRemove.forEach((lineItemKey)=> {
          updates[lineItemKey] = 0;
        });

        const requestBody = {
          updates
        };

        try {
          const response = await fetch(`${routes.cart_update_url}`, {
            method: `POST`,
            headers: {
              "Content-Type": `application/json`,
              "Accept": `application/javascript`
            },
            body: JSON.stringify(requestBody)
          });

          window.location.reload();
        } catch (error) {
          console.log(`Error updating cart: `, error);
        } finally {
          document.documentElement.dispatchEvent(
            new CustomEvent(`theme:cartchanged`, { bubbles: true, cancelable: false })
          );
        }
      });
    });
  }
  
  const addChangeListeners = () => {
    if (!quantityAdjustors?.[0]) {
      return;
    }

    quantityAdjustors.forEach(adjustor => {
      const sourceUuid = adjustor.getAttribute(`data-uuid`);
      
      let sourceVariantId = adjustor.getAttribute(`data-variantid`);

      if (!sourceVariantId) {
        return;
      }
      
      sourceVariantId = parseInt(sourceVariantId);

      adjustor.addEventListener(`keydown`, (e) => {
        if (e.key === `Enter`) {
          e.preventDefault();
        }
      });

      adjustor.addEventListener(`change`, async e => {
        const newQuantity = e.currentTarget.value;

        let updates = {};

        if (typeof sourceUuid === `undefined` || sourceUuid?.trim() === ``) {
          const itemToUpdate = liquidData.items.filter(({ id, properties }) => {
            return parseInt(sourceVariantId) === parseInt(id) && typeof properties?.__uuid === `undefined`;
          }).map(({ key }) => key?.toString());

          updates = {
            [itemToUpdate]: parseInt(newQuantity)
          }

          
        } else {
          const itemsToUpdate = liquidData.items.filter(({ id, properties }) => {
            return parseInt(sourceVariantId) === parseInt(properties?.__sourceVariant) && sourceUuid?.toString() === properties?.__uuid?.toString();
          }).map(({ key }) => key?.toString());

          const sourceItemKey = liquidData.items.find(({ id, properties }) => {
            return parseInt(sourceVariantId) === parseInt(id) && sourceUuid?.toString() === properties?.__uuid?.toString();
          })?.key?.toString();

          itemsToUpdate.push(sourceItemKey);

          itemsToUpdate.forEach((lineItemKey)=> {
            updates[lineItemKey] = parseInt(newQuantity);
          });
        }

        const requestBody = {
          updates
        };

        try {
          const response = await fetch(`${routes.cart_update_url}`, {
            method: `POST`,
            headers: {
              "Content-Type": `application/json`,
              "Accept": `application/javascript`
            },
            body: JSON.stringify(requestBody)
          });

          window.location.reload();
        } catch (error) {
          console.log(`Error updating cart: `, error);
        } finally {
          document.documentElement.dispatchEvent(
            new CustomEvent(`theme:cartchanged`, { bubbles: true, cancelable: false })
          );
        }
      }, false);
    });
  }


  // ----------------------------------------------------------------------- //
  // main
  
  const main = () => {
    merge();
    
    appendAddons();
    
    addClickListeners();
    
    addChangeListeners();
  }

  main();
}

export default LAMMainCart;